import placeholder from "@/assets/journal-placeholder.jpg";
import mealBreakfast from "@/assets/meal-breakfast.jpg";
import mealLunch from "@/assets/meal-lunch.jpg";
import mealDinner from "@/assets/meal-dinner.jpg";
import mealSnacks from "@/assets/meal-snacks.jpg";
import productJuice from "@/assets/product-juice.jpg";
import { POSTS } from "@/lib/blog-posts";

export type ArticleItem = {
  id: string;
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  author: string;
  image: string;
  alt: string;
  body: string[];
  isDemo: boolean;
  publishedAt?: string | null;
};

export const JOURNAL_PLACEHOLDER = placeholder;

const SLUG_IMAGES: Record<string, string> = {
  "planning-meals-for-busy-professionals": mealLunch,
  "fresh-vs-frozen-meal-prep": mealDinner,
  "meal-cutoff-timings-explained": mealBreakfast,
  "meal-cut-off-timings": mealBreakfast,
  "sourcing-from-local-farms": productJuice,
  "choosing-your-meal-plan": mealSnacks,
};

export function imageForSlug(slug: string | null | undefined): string | null {
  const key = typeof slug === "string" ? slug.trim().toLowerCase() : "";
  return SLUG_IMAGES[key] ?? null;
}

export function isValidHttpsUrl(v: string | null | undefined): v is string {
  if (!v) return false;
  // Site-relative paths (Media Library assets, bundled CDN images) are valid.
  if (v.startsWith("/") && !v.startsWith("//")) return true;
  try {
    return new URL(v).protocol === "https:";
  } catch {
    return false;
  }
}

export function deriveAlt(stored: string | null | undefined, title: string): string {
  const t = typeof stored === "string" ? stored.trim() : "";
  if (t.length > 0) return t;
  const derived = `${title} — Journal article`.trim();
  return derived.length > 0 ? derived : "Journal article image";
}

export function formatArticleDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export const ARTICLES_FALLBACK: ArticleItem[] = POSTS.map((p) => ({
  id: `fallback-${p.slug}`,
  slug: p.slug,
  category: p.category,
  title: p.title,
  excerpt: p.excerpt,
  date: p.date,
  readTime: p.readTime,
  author: p.author,
  image: p.image,
  alt: p.alt,
  body: p.body,
  isDemo: true,
}));